import { Grid, Typography } from "@mui/material";

const ErrorsField = ({ error }) => {
    return <Grid item>{typeof error === "string" ? <Typography color="error">{error}</Typography> : null}</Grid>;
};

export default ErrorsField;
